var $ = require('jquery');
var template = require('./banner-template.hbs');
var cookies = require('js-cookie');

function injectSolidarityBanner(element) {
    if (!cookies.get('solidarity-banner')) {
        $(element).prepend(template({
            linkUrl: location.origin + '/ukraine'
        }));
    }

    $('.solidarity-banner__close').click(() => {
        $('.solidarity-banner').remove();
        cookies.set('solidarity-banner', true, {expires: 7});
    });
}

module.exports = injectSolidarityBanner;